export default "__VITE_ASSET__lt23ElpB__"